// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { accountTilesStyles } from "@guestsupply/App/Widgets/AccountTiles/AccountTiles";
import { dashboardPanelsStyles } from "@guestsupply/App/Widgets/DashboardPanels/DashboardPanels";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

dashboardPanelsStyles.panlesWrapper = {
    css: css`
        padding-bottom: 5px;
    `,
};
dashboardPanelsStyles.itemWrapper = {
    width: [12, 12, 6, 6, 4],
    css: css`
        display: flex;
        padding: 10px;
    `,
};
dashboardPanelsStyles.clickablePanel = {
    css: css`
        width: 100%;
    `,
};
dashboardPanelsStyles.blockContent = {
    ...accountTilesStyles.blockContent,
};
dashboardPanelsStyles.iconContainer = {
    ...accountTilesStyles.item?.imageContainer,
};
dashboardPanelsStyles.textWrapper = {
    ...accountTilesStyles.titleWrapper,
};
dashboardPanelsStyles.panelText = {
    ...accountTilesStyles.item?.title,
    size: 18,
};
dashboardPanelsStyles.panelCount = {
    ...accountTilesStyles.item?.number,
};
